import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { finalize, map, takeUntil } from 'rxjs/operators';
import { VMovement } from 'src/app/models/entities/v-movement';
import { LogoService } from 'src/app/services/logo.service';
import { MovementService } from 'src/app/services/movement.service';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-movement',
  templateUrl: './movement.component.html',
  styleUrls: ['./movement.component.css']
})
export class MovementComponent implements OnInit {

  progress: boolean = false;
  displayModal: boolean = false;
  repeatModal: boolean = false;
  logoError: boolean = false;
  value: number = 0;
  destroy$ = new Subject<void>();
  movements$: Observable<VMovement[]>;
  selectedRecords: VMovement[];
  repeatRecord: VMovement;
  year: number = new Date().getFullYear();
  month: number = new Date().getMonth() + 1;
  exportDatas: any[] = [];
  logoErrorMessage: string;
  loading: boolean;
  today = new Date(this.year, this.month - 1, 2);
  startDay = "1";
  endDay = new Date(this.today.getFullYear(), this.today.getMonth() + 1, 1).toISOString().substring(8, 10);


  @ViewChild('dt', { static: false }) dt: any;
  constructor(
    private movementService: MovementService,
    private logoService: LogoService,
    private toastrService: ToastrService) { }

  ngOnInit(): void {
    this.getList();
  }

  loadDates() {
    this.today = new Date(this.year, this.month - 1, 2);
    this.startDay = "1";
    this.endDay = new Date(this.today.getFullYear(), this.today.getMonth() + 1, 1).toISOString().substring(8, 10);
    this.movements$ = new Observable<VMovement[]>();
  }


  getList() {
    this.loading = true;
    this.selectedRecords = [];
    this.exportDatas = [];
    this.movements$ = this.movementService.getList(this.year, this.month, this.startDay, this.endDay).pipe(map(result => result.data), finalize(() => this.loading = false));
    this.movementService.getList(this.year, this.month, this.startDay, this.endDay).pipe(takeUntil(this.destroy$)).subscribe(result => {
      for (let value of result.data) {
        this.exportDatas.push(
          {
            "Platform Adı": value.portalName,
            "Müşteri Kodu": value.customerCode,
            "Müşteri Adı": value.customerName,
            "Proje Adı": value.projectName,
            "Hizmet": value.serviceName,
            "Abonelik Tipi": value.contractTypeName,
            "Terminal Adedi": value.numberOfTerminals,
            "Birim Fiyat": value.serviceUnitPrice,
            "Para Birimi": value.currencyUnit,
            "Başlangıc Tarihi": value.startDate,
            "Bitiş Tarihi": value.endDate,
            "Fatura Tarihi": value.invoiceDate,
            "Notlar": value.notes,
            "Bayi Adı": value.dealerName,
            "Yıl": this.year,
            "Ay": this.month,
            "İşlem Tarihi": value.processDate,
            "Durum": value.recordStatusName
          }
        )
      }
    })
  }


  applyFilterGlobal($event: Event, stringVal: string) {
    this.dt.filterGlobal(($event.target as HTMLInputElement).value, 'contains');
  }


  createOrder() {

    if (this.selectedRecords.length != 0) {
      this.logoService.checkExchanges(this.selectedRecords).pipe(takeUntil(this.destroy$)).subscribe(result => {
        this.displayModal = true;
        this.progress = true;
        let interval = setInterval(() => {
          this.value = this.value + Math.floor(Math.random() * 10) + 1;
          if (this.value >= 100) {
            this.value = 99;
          }
        }, 2000);
        this.logoService.createOrder(this.selectedRecords).pipe(takeUntil(this.destroy$)).subscribe(result => {
          clearInterval(interval);
          this.displayModal = false;
          this.progress = false;
          this.value = 0;
          this.getList();
          if (result.message.length > 0) {
            this.logoError = true;
            this.logoErrorMessage = result.message;
          }
          else {
            this.toastrService.success("Siparişler oluşturuldu.", "BAŞARILI!");
          }
        },
          er => {
            clearInterval(interval);
            this.displayModal = false;
            this.progress = false;
            this.value = 0;
            this.getList();
            this.toastrService.warning(er.error.message, "LOGO GİRİŞ HATASI!");
          }
        );
      },
        er => {
          this.toastrService.warning(er.error.message, "HATA!");
        }
      )
    }
  }


  repeat(movement: VMovement) {
    this.repeatModal = true;
    this.repeatRecord = movement;
  }

  repeatSave() {

    this.logoService.repeatCreateOrder(this.repeatRecord).pipe(takeUntil(this.destroy$)).subscribe(result => {
      if (result.message.length > 0) {
        this.logoError = true;
        this.logoErrorMessage = result.message;
      }
      else {
        this.toastrService.success("Sipariş tekrar oluşturuldu.", "BAŞARILI!");
      }
      this.repeatModal = false;
      this.getList();
    },
      er => {
        this.toastrService.warning(er.error.message, "HATA!");
      }
    );

  }


  ngOnDestroy(): void {
    this.destroy$.next();
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.exportDatas);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, this.month.toString() + "/" + this.year.toString() + " - Hareket Tablosu");
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }

}
